import type { SamplingArea, ToGeoJSON } from '../../../types/apiModels'
import { getRandomColor } from '../../../utils/mapDrawHandle'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection, unwrapVoid } from '../../ruutsApi/normalize'

type SamplingAreaInput = {
  farmId: string
  features: ToGeoJSON[]
}

const featuresFarmToEntities = ({ farmId, features }: SamplingAreaInput) =>
  features.map(feature => ({
    farmId,
    geometry: feature.geometry,
    id: feature?.properties?.id,
    name: feature.properties.name,
    color: feature.properties.color ? feature.properties.color : getRandomColor(),
  }))

export const createSamplingAreasFeatureByFarm = async ({
  farmId,
  features,
}: SamplingAreaInput): Promise<SamplingArea[]> => {
  if (!features?.length) return []

  const featuresToCreate = featuresFarmToEntities({ farmId, features })
  const response = await apiClient.post(endpoints.samplingAreas, featuresToCreate)
  return unwrapCollection<SamplingArea>(response)
}

// PUT /v1/samplingAreas answers a message-only envelope (no payload): unwrapping a
// payload here would throw after the server already committed the write. Consumers
// refresh via invalidateQueries, never by seeding the cache with this response.
export const updateSamplingAreasFeatureByFarm = async ({
  farmId,
  features,
}: SamplingAreaInput): Promise<void> => {
  if (!features?.length) return undefined

  const featuresToUpdate = featuresFarmToEntities({ farmId, features })
  const response = await apiClient.put(endpoints.samplingAreas, featuresToUpdate)
  return unwrapVoid(response)
}
